import { Filter } from '@elderbyte/ngx-starter'

export class DeliveryFilterBuilder {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private _facility: string
  private _targetFacility: string
  private _hasTargetFacility: boolean
  private _orderReferenceNumbers: string[]

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static facility(facility: string): Filter {
    return this.start().facility(facility).build()[0]
  }

  public static orderReferenceNumbers(...orderReferenceNumber: string[]): Filter {
    return this.start()
      .orderReferenceNumbers(...orderReferenceNumber)
      .build()[0]
  }

  public static start(): DeliveryFilterBuilder {
    return new DeliveryFilterBuilder()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public facility(facility: string): DeliveryFilterBuilder {
    this._facility = facility
    return this
  }

  public targetFacility(facility: string): DeliveryFilterBuilder {
    if (facility) {
      this._targetFacility = facility
      this._hasTargetFacility = null
    } else {
      this._hasTargetFacility = false
      this._targetFacility = null
    }
    return this
  }

  public orderReferenceNumbers(...orderReferenceNumbers: string[]): DeliveryFilterBuilder {
    this._orderReferenceNumbers = orderReferenceNumbers
    return this
  }

  public build(): Filter[] {
    const filters: Filter[] = []

    if (this._facility) {
      filters.push(new Filter('facility', this._facility))
    }

    if (this._targetFacility) {
      filters.push(new Filter('targetFacility', this._targetFacility))
    }

    if (this._hasTargetFacility != null) {
      filters.push(new Filter('hasTargetFacility', String(this._hasTargetFacility)))
    }

    if (this._orderReferenceNumbers) {
      filters.push(new Filter('orderReferenceNumbers', this._orderReferenceNumbers))
    }

    return filters
  }
}
